export default{
    state:{
    },
    mutations:{
    },
    actions:{
        async payLink({ dispatch }, id){
            return await dispatch('apiQuery', {method: `/pay/create_url/${id}`})
        }
    },
    getters:{
    }
}